import BaseAPI from './base.api';

export default class FrameFatigueAPI extends BaseAPI {
  getOverview = async (startDate: string, endDate: string) => {
    const response = await this.API.get('frame-fatigue/overview', {
      params: { startDate, endDate },
    });
    return response.data;
  };

  getCriticalAssets = async (
    startDate: string,
    endDate: string,
    bumperId?: string
  ) => {
    const response = await this.API.get('frame-fatigue/critical-assets', {
      params: { startDate, endDate, bumperId },
    });
    return response.data;
  };

  getAssetDetail = async (
    bumperId: string,
    startDate: string,
    endDate: string,
    selectedDate?: string
  ) => {
    const response = await this.API.get('frame-fatigue/critical-assets', {
      params: { bumperId, startDate, endDate, selectedDate },
    });
    return response.data;
  };
}
